.timeWrapper {
  display: flex;
  align-items: stretch;
  margin-top: var(--mantine-spacing-md);
}

.timeInput {
  flex: 1;
  margin-inline-end: var(--mantine-spacing-md);
}

.rangeInfo {
  margin-top: var(--mantine-spacing-md);
  font-size: calc(var(--mantine-font-size-sm) - rem(2px));
  color: var(--mantine-color-text);
  line-height: 1.4;
  height: calc((var(--mantine-font-size-sm) - rem(2px)) * 1.4);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rangeTimeWrapper {
  display: flex;
  align-items: stretch;
  gap: var(--mantine-spacing-md);
  margin-top: var(--mantine-spacing-md);
}

.rangeTimeInput {
  flex: 1;
}
